module.exports = __webpack_public_path__ + "img/2668da9.jpg";